import { render, staticRenderFns } from "./artifact-block.vue?vue&type=template&id=6e228ba3&scoped=true"
import script from "./artifact-block.vue?vue&type=script&lang=ts"
export * from "./artifact-block.vue?vue&type=script&lang=ts"
import style0 from "./artifact-block.vue?vue&type=style&index=0&id=6e228ba3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e228ba3",
  null
  
)

export default component.exports